<template>
  <!-- 测试用 -->
  <div class='test'>
    <h2 @click='test'>微信登录</h2>
    <div id='box' class='box'/>
  </div>
</template>

<script>
export default {
  methods: {
    test() {
      console.log('test ')
      var obj = new WxLogin({
        self_redirect: false,
        id: 'box',
        appid: 'wx75b16abea9ba03db',
        scope: 'snsapi_login',
        redirect_uri: encodeURI('http://fan.35wi.com/'),
        state: '',
        style: '',
        href: ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.test {
  width: 900px;
  height: 900px;
  background-color: #f0f0f0;
  margin: 0 auto;
  padding: 50px;

  h2 {
    text-align: center;
  }

  .box {
    width: 500px;
    height: 500px;
    background-color: #fff;
    margin: 50px auto 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Test.vue